module.exports = __webpack_public_path__ + "static/media/pos-icon.acdd7e8c.svg";